<template lang="pug">
  div(class="content")
    div(class="md-layout" style="height: 70vh;")
      div(class="md-layout-item md-size-10 md-xsmall-size-100 centered")
        md-button.md-raised(v-if="!notLoaded" :href="source" target="_blank") Open in New Window
      div(v-if="notLoaded" class="md-layout-item md-size-100 centered")
        loading
      iframe(:class="[{loading: notLoaded}, 'md-image']" @load="notLoaded = false" :src="source" width="96%" height="100%" frameborder="0")
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return{
      source: 'https://calendar.google.com/calendar/embed?src=usiteam.org_et86f0qih39bgssrfb73cttbuo%40group.calendar.google.com&ctz=America%2FChicago',
      notLoaded: true,
    };
  }
}
</script>

<style scoped>
  .content {
    padding-top: 0px;
  }

  .centered {
    text-align: center;
  }

  .loading {
    display: none;
  }

  iframe {
    margin-left: 1%;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Events/Calendar.vue